// extracted by mini-css-extract-plugin
export default {"head":"Home_head__-HEA-","div1":"Home_div1__lkO9+","txt":"Home_txt__yn9FK","btn1":"Home_btn1__yaigO"};